import axios from "axios";
import { notify } from "@/package/helpers/notify";
import { useCookies } from "@vueuse/integrations/useCookies";
import router from "@/router";
import { RouteNames } from "@/router/routes";

export const BASE_URL = import.meta.env.VITE_BACKEND_URL;

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  withCredentials: true,
});

API.defaults.headers.post["Content-Type"] = "application/json";
API.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";

// Инициализация useCookies
const { get } = useCookies();

// Интерсептор для добавления токена
API.interceptors.request.use(
  function (config) {
    const token = get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Редирект на страницу блокировки
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.slug === "admin.blocked"
    ) {
      router.replace({ name: RouteNames.BLOCKED_VIEW });
    }
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response.status === 401 &&
      error.response.data.slug === "auth.invalid_access_token"
    ) {
      notify("error", "Ошибка", "Ошибка авторизации");
      router.replace({ name: RouteNames.LOGIN_VIEW });
    }
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response.status === 403 &&
      error.response.data.slug === "admin.not.access"
    ) {
      router.replace({ name: RouteNames.LOGIN_VIEW });
    }
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 500) {
        notify("error", "Ошибка", "Произошла ошибка на сервере");
      }
    }
    return Promise.reject(error);
  }
);

export default API;
